"use strict";

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

define('controllers/sentinelController',["require", "exports", "controllers/abortingRequest", "providers/ajaxSettingsProvider"], function (require, exports, abortingRequest, ajaxSettingsProvider) {
    "use strict";

    var SentinelController = function () {
        function SentinelController() {
            _classCallCheck(this, SentinelController);
        }

        _createClass(SentinelController, [{
            key: "filters",
            value: function filters(data) {
                return abortingRequest.send('/api/sentinel/Filters', ajaxSettingsProvider.httpPost(data), false, false);
            }
        }, {
            key: "logBaseTileChange",
            value: function logBaseTileChange(data) {
                return abortingRequest.send('/api/sentinel/LogBaseTileChange', ajaxSettingsProvider.httpPost(data), false, false);
            }
        }, {
            key: "logEnvironmentChange",
            value: function logEnvironmentChange(data) {
                return abortingRequest.send('/api/sentinel/LogEnvironmentChange', ajaxSettingsProvider.httpPost(data), false, false);
            }
        }, {
            key: "logPolicyActivity",
            value: function logPolicyActivity(data) {
                return abortingRequest.send('/api/sentinel/LogPolicyActivity', ajaxSettingsProvider.httpPost(data), false, false);
            }
        }, {
            key: "logWatchPolicyViewed",
            value: function logWatchPolicyViewed(data) {
                return abortingRequest.send('/api/sentinel/LogWatchPolicyViewed', ajaxSettingsProvider.httpPost(data), false, false);
            }
        }, {
            key: "fetchLatestSessions",
            value: function fetchLatestSessions(data) {
                return abortingRequest.send('/api/sentinel/FetchLatestSessions', ajaxSettingsProvider.httpPost(data, 300000));
            }
        }, {
            key: "fetchActivityForSession",
            value: function fetchActivityForSession(data) {
                return abortingRequest.send('/api/sentinel/FetchActivityForSession', ajaxSettingsProvider.httpPost(data), true);
            }
        }, {
            key: "fetchPolicyActivities",
            value: function fetchPolicyActivities(data) {
                return abortingRequest.send('/api/sentinel/FetchPolicyActivities', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "fetchSessionsForPolicyActivity",
            value: function fetchSessionsForPolicyActivity(data) {
                return abortingRequest.send('/api/sentinel/FetchSessionsForPolicyActivity', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "fetchActivityForPolicyInteractionSession",
            value: function fetchActivityForPolicyInteractionSession(data) {
                return abortingRequest.send('/api/sentinel/FetchActivityForPolicyInteractionSession', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "fetchLatestSessionsForPolicy",
            value: function fetchLatestSessionsForPolicy(data) {
                return abortingRequest.send('/api/sentinel/FetchLatestSessionsForPolicy', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "fetchActivityForPolicySession",
            value: function fetchActivityForPolicySession(data) {
                return abortingRequest.send('/api/sentinel/FetchActivityForPolicySession', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "fetchLatestUserSessions",
            value: function fetchLatestUserSessions(data) {
                return abortingRequest.send('/api/sentinel/FetchLatestUserSessions', ajaxSettingsProvider.httpPost(data));
            }
        }, {
            key: "fetchLatestDispatchSessions",
            value: function fetchLatestDispatchSessions(data) {
                return abortingRequest.send('/api/sentinel/FetchLatestDispatchSessions', ajaxSettingsProvider.httpPost(data));
            }
        }]);

        return SentinelController;
    }();

    return new SentinelController();
});
//# sourceMappingURL=sentinelController.js.map;
